import { decide } from '../ai/brain';
import type { Command } from '../sim/commands';
import type { Grid } from '../sim/path';
import type { GameState } from '../sim/types';
import type { CommandSource } from './CommandSource';

/*
 * מקור הפקודות של היריב.
 *
 * **כל מה שיש כאן הוא הדבקה.** ההחלטות חיות ב-`ai/brain.ts` שהוא טהור ונבדק;
 * המחלקה הזו רק מחתימה טיק, שחקן ומונה — בדיוק כפי ש-`LocalCommandSource` עושה
 * לשחקן. זו הסיבה שהיא יושבת ב-`game/` ולא ב-`ai/`: היא נוגעת במצב החי.
 *
 * **בלי השהיית קלט, בכוונה.** לשחקן יש INPUT_DELAY_TICKS כי הפקודות שלו יעברו
 * יום אחד ברשת; ל-AI אין רשת. במקום זה יש לו השהיה גדולה בהרבה וגלויה —
 * `decisionIntervalTicks`. פקודה תלויה באוויר ברגע השמירה הייתה גם הופכת את
 * "המשך משחק" ללא-מדויק, וזו הבטחה שאנחנו לא שוברים בשביל 100 מילישניות.
 *
 * המונה `seq` מתאפס בטעינה, וזה תקין: הוא קובע סדר בתוך טיק בין פקודות של אותו
 * שחקן, ו-`decide` מייצר אותן באותו סדר בכל פעם.
 */

export class AiCommandSource implements CommandSource {
    private seq = 0;

    constructor(
        private readonly readState: () => GameState,
        private readonly grid: Grid,
        private readonly player: number,
    ) {}

    drain(tick: number): Command[] {
        const state = this.readState();
        /*
         * החלטה על מצב שאינו הטיק שנשאלנו עליו הייתה מכניסה את ה-AI לזרם RNG
         * של טיק אחר — אותו משחק בדיוק היה רץ אחרת.
         */
        if (state.tick !== tick) return [];

        return decide(state, this.grid, this.player).map(
            (draft) => ({ ...draft, tick, player: this.player, seq: this.seq++ }) as Command,
        );
    }

    ready(): boolean {
        return true;
    }
}
